import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CustomHttpInterceptor } from "providers/custom-http-interceptor/custom-http.interceptor";
import { AuthorizationHttpInterceptor } from "../../../app/authorization/AuthorizationHttpInterceptor";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { IDGDataService } from "../../../providers/idg-data-service/idg-data-service";
import { CreateIDGMeetingModalPage } from "./create-idg-meeting-modal";

@NgModule({
  declarations: [CreateIDGMeetingModalPage],
  imports: [
    IonicPageModule.forChild(CreateIDGMeetingModalPage),
    TranslateModule.forChild(),
    CommonComponentsModule,
  ],
  providers: [
    IDGDataService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
  ],
})
export class CreateIDGMeetingModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/inter-disciplinary-group/create-idg-meeting-modal/create-idg-meeting-modal.module.ts